import { createAction, props } from '@ngrx/store';
import { WidgetId } from '../selectors/widgets.selector';

export enum WidgetsActions {
  WidgetsOrderSaved = '[Widgets] Order Saved',
}

export const widgetsOrderSaved = createAction(
  WidgetsActions.WidgetsOrderSaved,
  props<{
    widgetsOrder: WidgetId[];
  }>(),
);
